<script>
import TwModal from '@/components/generic/modal/tw-modal.vue'
import TwWizard from '@/components/generic/wizard/tw-wizard.vue'
import TwWizardPage from '@/components/generic/wizard/tw-wizard-page.vue'
import OrganizationEdit from '@/components/organizations/organization-edit.vue'
import RegisterUserAccount from '@/components/user/register-user-account.vue'
import UserPage from '@/pages/UserPage.vue'
import { useOrganizationStore } from '@/stores/organization.js'
import { useAuthStore } from '@/stores/auth.js'
import { useOrganizationPublicStore } from '@/stores/organizationPublic.js'

export default {
  name: 'OrganizationRegisterModal',
  components: { OrganizationEdit, RegisterUserAccount, TwWizardPage, TwWizard, TwModal },
  data() {
    return {
      Organization: undefined,
      UserAccount: null,
      LoadingCreatingOrganization: false
    }
  },
  computed: {
    validForm() {
      return true; //  !!(this.OrganizationName && this.OrganizationAddress && this.OrganizationCity && this.OrganizationState && this.OrganizationZipCode && this.OrganizationTaxIdNumber && this.OrganizationWebsite && this.OrganizationDescription)
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    async userRegistered(userRegistered) {
      try {
        this.LoadingCreatingOrganization = true
        await useOrganizationPublicStore().itemPatch({
          id: this.Organization.id,
          owner_user_id: userRegistered.id
        })
        this.LoadingCreatingOrganization = false
        await this.$refs.modal.close()
        await useAuthStore().login({
          email: this.UserAccount.email,
          password: this.UserAccount.password,
        })
        await this.$router.push({ name: 'DashboardPage' })
      } catch (e) {
        this.LoadingCreatingOrganization = false
      }
    }
  }
}
</script>

<template>
  <tw-modal ref="modal" no-footer :loading="LoadingCreatingOrganization" modal-id="organization-register-modal" title="Register with GroupRev" :ok-disabled="!validForm">
    <tw-wizard ref="wizard" no-navigation>
      <tw-wizard-page>
        <organization-edit ref="organizationEdit" v-model="Organization" public @created="$refs.wizard.nextPage()" />
      </tw-wizard-page>
      <tw-wizard-page>
        <register-user-account ref="registerUsers" v-model="UserAccount" user-role="organization" @user-registered="userRegistered" @cancel-registration="$refs.modal.close()" />
        <div v-if="UserAccount && UserAccount.id">
          <h2> User account created, finish to log in: </h2>
          <p> {{ UserAccount.email }} </p>
        </div>
      </tw-wizard-page>
    </tw-wizard>
    <template #ok>
      Register Organization
    </template>
  </tw-modal>
</template>

<style scoped>

</style>
